import { ApolloCache, Reference } from "@apollo/client";
import { ModifierDetails } from "@apollo/client/cache";

/**
 * Updates the Apollo cache after removing a saved search.
 *
 * This function modifies the `getSavedSearch` field in the cache by filtering out
 * the search entry with the given `searchId`.
 *
 * @param searchId - The ID of the saved search to remove.
 * @returns A function that takes the Apollo cache object and performs the cache modification.
 */

export const updateCacheAfterSavedSearchRemoval =
  (searchId: string) => (cache: ApolloCache<any>) => {
    cache.modify({
      fields: {
        getSavedSearch: (
          previous: readonly Reference[],
          { readField }: ModifierDetails
        ) => {
          return previous?.filter((d) => readField("searchId", d) !== searchId);
        },
      },
    });
  };
